module.exports = __webpack_public_path__ + "static/media/ironUmp.3543a37a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ironUmp.svg
// module id = 508
// module chunks = 0